<!-- <div class="block h-full w-full"> -->
<canvas class="h-64" baseChart [datasets]="barChartData.datasets" [labels]="barChartData.labels"
    [options]="barChartOptions" [type]="'bar'" [plugins]="barChartPlugins">
</canvas>
<!-- </div> -->